import * as STD                            from '@emersya/mpa-std-lib';
import CM              from '@emersya/mpa-components-manager-lib';
import ViewerComponent from '../../../viewer/Viewer/Viewer';

export interface IStandingPlinthComponentConfiguration extends CM.Component.IConfiguration {
	// To not duplicate many property of the app configuration, and because this component is unique, retrieve conf directly from app and lets this interface be empty.
};

export class StandingPlinthComponent extends CM.Component<
	StandingPlinthComponent,
	IStandingPlinthComponentConfiguration
>
{
	readonly plannerCategory! : ViewerComponent.ProductCategory;
	viewerNode : ViewerComponent.ProductInstance | null = null;
	currentLayoutId : string | null = null;

	getWDH() {
		const p = app.currentProduct;
		if (!p) {
			this.component_throwUserError('');
		}
		const dpart = p.getPart([ 'dimensions' ]);
		return {
			width :  Number.parseFloat(dpart.getPart([ 'width' ])?.reference?.value || <string> <any> 1),
			depth :  Number.parseFloat(dpart.getPart([ 'depth' ])?.reference?.value || <string> <any> 1),
			height : Number.parseFloat(dpart.getPart([ 'height' ])?.reference?.value || <string> <any> 1)
		};
	};

	getWallThickness() {
		// TODO : DEHARDCODE
		return 0.05;
	}

	private computeMatrix(side : string) : {
		matrix : ViewerComponent.TMatrix;
		textureTransform : ViewerComponent.INative_transformMeshInstancesTextures_descriptor['transform'];
	}
	{
		const wdh = this.getWDH();
		const x = wdh.width === 0 ? 5 : wdh.width;
		const y = wdh.height;
		const z = wdh.depth === 0 ? 5 : wdh.depth;
		void x;
		void y;
		void z;
		const product = app.currentProduct;
		const heightCarpet = 0.001;
		if (!product) {
			throw STD.errors.user('No current product available!');
		}
		const carpetImprint = app.component_configuration.productsComponents.find(x => x.type === 'carpetImprint');
		if (!carpetImprint) {
			throw STD.errors.user('Missing carpet imprint component');
		}
		const boundingBox = carpetImprint.boundingBox;
		if (!boundingBox) {
			throw STD.errors.user('Missing boundign box for carpet imprint');
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			throw STD.errors.user('No part layout available');
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			throw STD.errors.user('No current option in layout part');
		}
		const layoutId = layoutCurrentOption.id;
		if (product.id === 'siae') {
			const transform = {
				translation :    [ 0, 0 ] as [ number, number ],
				scaling :        [ 1, 1 ] as [ number, number ],
				rotationCenter : [ 0, 0 ] as [ number, number ],
				rotation :       0,
				scaleX :         1,
				scaleY :         1
			};
			if (side === 'left' || side === 'right' || side === 'back') {
				return {
					matrix :           ViewerComponent.mtx([ 1, 1, 1 ], [ 0, 0, 0 ], 0),
					textureTransform : transform
				};
			} else {
				if (layoutId === 'shape-no-wall' || layoutId === 'shape-back-left' || layoutId === 'shape-back') {
					return {
						matrix :           ViewerComponent.mtx([
							x / 2 - boundingBox.width / 2 + 0.1,
							heightCarpet,
							z / 2 - boundingBox.depth / 2 + 0.25
						], [ 1, 1, 1 ], 0),
						textureTransform : transform
					};
				} else if (layoutId === 'shape-back-right') {
					return {
						matrix :           ViewerComponent.mtx([
							-x / 2 + boundingBox.width / 2 - 0.1,
							heightCarpet,
							z / 2 - boundingBox.depth / 2 + 0.25
						], [ 1, 1, 1 ], 0),
						textureTransform : transform
					};
				} else if (layoutId === 'shape-left-back-right') {
					return {
						matrix :           ViewerComponent.mtx([
							x / 2 - boundingBox.width / 2 - 0.25,
							heightCarpet,
							z / 2 - boundingBox.depth / 2 + 0.25
						], [ 1, 1, 1 ], 0),
						textureTransform : transform
					};
				} else {
					throw STD.errors.user('Unknown layoutId in plinth');
				}
			}
		} else {
			if (layoutId === 'shape-no-wall') {
				if (side === 'left') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         0.5,
						scaleY :         z - (boundingBox.depth)
					};
					return {
						matrix :           ViewerComponent.mtx(
							[ -x / 2 + (boundingBox.depth / 4), heightCarpet, 0 ],
							[ 0.5, 1, z - (boundingBox.depth) ],
							0
						),
						textureTransform : transform
					};
				} else if (side === 'right') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         0.5,
						scaleY :         z - (boundingBox.depth)
					};
					return {
						matrix :           ViewerComponent.mtx(
							[ x / 2 - (boundingBox.depth / 4), heightCarpet, 0 ],
							[ 0.5, 1, z - (boundingBox.depth) ],
							0
						),
						textureTransform : transform
					};
				} else if (side === 'front') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         x,
						scaleY :         0.5
					};
					return {
						matrix :           ViewerComponent.mtx([ 0, heightCarpet, z / 2 - (boundingBox.depth / 4) ], [ x, 1, 0.5 ], 0),
						textureTransform : transform
					};
				} else if (side === 'back') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         x,
						scaleY :         0.5
					};
					return {
						matrix :           ViewerComponent.mtx([ 0, heightCarpet, -z / 2 + (boundingBox.depth / 4) ], [ x, 1, 0.5 ], 0),
						textureTransform : transform
					};
				} else {
					throw STD.errors.user('Unknown side');
				}
			} else if (layoutId === 'shape-back-left') {
				if (side === 'left') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         1,
						scaleY :         1
					};
					return {
						matrix :           ViewerComponent.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0),
						textureTransform : transform
					};
				} else if (side === 'right') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         0.5,
						scaleY :         z - boundingBox.depth / 2
					};
					return {
						matrix :           ViewerComponent.mtx(
							[ x / 2 - boundingBox.depth / 4, heightCarpet, -boundingBox.depth / 4 ],
							[ 0.5, 1, z - boundingBox.depth / 2 ],
							0
						),
						textureTransform : transform
					};
				} else if (side === 'front') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         x,
						scaleY :         0.5
					};
					return {
						matrix :           ViewerComponent.mtx([ 0, heightCarpet, z / 2 - (boundingBox.depth / 4) ], [ x, 1, 0.5 ], 0),
						textureTransform : transform
					};
				} else if (side === 'back') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         1,
						scaleY :         1
					};
					return {
						matrix :           ViewerComponent.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0),
						textureTransform : transform
					};
				} else {
					throw STD.errors.user('Unknown side');
				}
			} else if (layoutId === 'shape-back') {
				if (side === 'left') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         0.5,
						scaleY :         z - boundingBox.depth / 2
					};
					return {
						matrix :           ViewerComponent.mtx(
							[ -x / 2 + boundingBox.depth / 4, heightCarpet, -boundingBox.depth / 4 ],
							[ 0.5, 1, z - boundingBox.depth / 2 ],
							0
						),
						textureTransform : transform
					};
				} else if (side === 'right') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         0.5,
						scaleY :         z - boundingBox.depth / 2
					};
					return {
						matrix :           ViewerComponent.mtx(
							[ x / 2 - boundingBox.depth / 4, heightCarpet, -boundingBox.depth / 4 ],
							[ 0.5, 1, z - boundingBox.depth / 2 ],
							0
						),
						textureTransform : transform
					};
				} else if (side === 'front') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         x,
						scaleY :         0.5
					};
					return {
						matrix :           ViewerComponent.mtx([ 0, heightCarpet, z / 2 - (boundingBox.depth / 4) ], [ x, 1, 0.5 ], 0),
						textureTransform : transform
					};
				} else if (side === 'back') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         1,
						scaleY :         1
					};
					return {
						matrix :           ViewerComponent.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0),
						textureTransform : transform
					};
				} else {
					throw STD.errors.user('Unknown side');
				}
			} else if (layoutId === 'shape-back-right') {
				if (side === 'left') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         0.5,
						scaleY :         z - boundingBox.depth
					};
					return {
						matrix :           ViewerComponent.mtx(
							[ -x / 2 + boundingBox.depth / 4, heightCarpet, -boundingBox.depth / 4 ],
							[ 0.5, 1, z - boundingBox.depth / 2 ],
							0
						),
						textureTransform : transform
					};
				} else if (side === 'right') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         1,
						scaleY :         1
					};
					return {
						matrix :           ViewerComponent.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0),
						textureTransform : transform
					};
				} else if (side === 'front') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         x,
						scaleY :         0.5
					};
					return {
						matrix :           ViewerComponent.mtx([ 0, heightCarpet, z / 2 - (boundingBox.depth / 4) ], [ x, 1, 0.5 ], 0),
						textureTransform : transform
					};
				} else if (side === 'back') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         1,
						scaleY :         1
					};
					return {
						matrix :           ViewerComponent.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0),
						textureTransform : transform
					};
				} else {
					throw STD.errors.user('Unknown side');
				}
			} else if (layoutId === 'shape-left-back-right') {
				if (side === 'left') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         1,
						scaleY :         1
					};
					return {
						matrix :           ViewerComponent.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0),
						textureTransform : transform
					};
				} else if (side === 'right') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         1,
						scaleY :         1
					};
					return {
						matrix :           ViewerComponent.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0),
						textureTransform : transform
					};
				} else if (side === 'front') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         x,
						scaleY :         0.5
					};
					return {
						matrix :           ViewerComponent.mtx([ 0, heightCarpet, z / 2 - (boundingBox.depth / 4) ], [ x, 1, 0.5 ], 0),
						textureTransform : transform
					};
				} else if (side === 'back') {
					const transform = {
						translation :    [ 0, 0 ] as [ number, number ],
						scaling :        [ 1, 1 ] as [ number, number ],
						rotationCenter : [ 0, 0 ] as [ number, number ],
						rotation :       0,
						scaleX :         1,
						scaleY :         1
					};
					return {
						matrix :           ViewerComponent.mtx([ 0, 0, 0 ], [ 0, 0, 0 ], 0),
						textureTransform : transform
					};
				} else {
					throw STD.errors.user('Unknown side');
				}
			} else {
				throw STD.errors.user('Unknown layoutId in plinth');
			}
		}

	}

	async insert() {
		// insert nodes
		const product = app.currentProduct;
		if (this.viewerNode) {
			return;
		}
		if (!product) {
			this.component_throwUserError('');
		}
		const adequateCarpet = this.deduceAdequateCarpet();
		if (!adequateCarpet) {
			return;
		}
		const carpetImprintProductSchema = this.plannerCategory.products.find(x => x.SKU === adequateCarpet.SKU);
		if (!carpetImprintProductSchema) {
			this.component_throwLibraryError('');
		}
		const matrix : Record<string, ViewerComponent.TMatrix> = {};
		if (adequateCarpet.sides) {
			adequateCarpet.sides.forEach(element => {
				matrix[ element + 'Carpet' ] = this.computeMatrix(element).matrix;
			});
		} else {
			matrix[ 'frontCarpet' ] = this.computeMatrix('front').matrix;
		}
		this.viewerNode = await carpetImprintProductSchema.instantiate({
			rootLocalId : app.viewer.globalLocalId,
			appendType : 'insert',
			basketPart : null,
			basketUseDynamicTitleBinding : false,
			metadata : {
				id : this.id
			},
			matrixOverride : matrix
		});
		if (!this.viewerNode) {
			this.component_throwUserError('');
		}
		const lll = this.viewerNode;
		const listTransform : ViewerComponent.INative_transformMeshInstancesTextures_descriptor[] = [];
		if (adequateCarpet.sides) {
			adequateCarpet.sides.forEach(element => {
				const currentIdMapping = lll.idMapping[ element + 'Carpet' ];
				if (!currentIdMapping) {
					this.component_throwUserError('');
				}
				listTransform.push({
					name :        'MOQUETTE',
					nodeLocalId : currentIdMapping,
					transform :   this.computeMatrix(element).textureTransform
				});
			});
			await app.viewer.batch([
				[
					'transformMeshInstancesTextures',
					listTransform
				]
			]);
		}
		this.viewerNode.setName('carpet-imprint ' + this.id);
	};


	async preloadAfterGlobalProductChanged() {
		const product = app.currentProduct;
		if (!product) {
			this.component_throwUserError('');
		}
		const productComponent = app.component_configuration.productsComponents.find(x => x.type ===
			'carpetImprint' &&
			x.products.includes(product.id));
		if (!productComponent) {
			this.component_throwUserError('');
		}
		const node : any = {
			projectCode :   <string> productComponent.viewerProjectCode,
			SKU :           <string> productComponent.viewerComponentSKU,
			localId :       <number> app.viewer.getLocalId(),
			parentLocalId : app.viewer.globalLocalId,
			matrix :        app.viewer.mtx(
				[ 0, 0, 0 ],
				[ 1, 1, 1 ],
				0
			),
		};
		await app.viewer.addProductNodeInstance(node);
		await app.viewer.removeProductNodeInstance(node.localId);

	};

	async update() {
		const product = app.currentProduct;
		if (!product) {
			this.component_throwUserError('');
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			return;
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			return;
		}
		const layoutId = layoutCurrentOption.id;
		if (!this.viewerNode || !this.currentLayoutId || this.currentLayoutId != layoutId) {
			if (this.viewerNode) {
				await this.remove();
			}
			await this.insert();
			this.currentLayoutId = layoutId;
		} else {
			const idMapping = this.viewerNode.idMapping;
			const leftCarpet = this.computeMatrix('left');
			const rightCarpet = this.computeMatrix('right');
			const frontCarpet = this.computeMatrix('front');
			const backCarpet = this.computeMatrix('back');
			const nodesMtx : ViewerComponent.INative_setProductNodesInstancesMatrices_descriptor = [];
			const listTransform : ViewerComponent.INative_transformMeshInstancesTextures_descriptor[] = [];
			if (idMapping.leftCarpet) {
				nodesMtx.push({
					localId : idMapping.leftCarpet,
					matrix :  leftCarpet.matrix
				});
				listTransform.push({
					name :        'MOQUETTE',
					nodeLocalId : idMapping.leftCarpet,
					transform :   leftCarpet.textureTransform
				});
			}
			if (idMapping.frontCarpet) {
				nodesMtx.push({
					localId : idMapping.frontCarpet,
					matrix :  frontCarpet.matrix
				});
				listTransform.push({
					name :        'MOQUETTE',
					nodeLocalId : idMapping.frontCarpet,
					transform :   frontCarpet.textureTransform
				});
			}
			if (idMapping.rightCarpet) {
				nodesMtx.push({
					localId : idMapping.rightCarpet,
					matrix :  rightCarpet.matrix
				});
				listTransform.push({
					name :        'MOQUETTE',
					nodeLocalId : idMapping.rightCarpet,
					transform :   rightCarpet.textureTransform
				});
			}
			if (idMapping.backCarpet) {
				nodesMtx.push({
					localId : idMapping.backCarpet,
					matrix :  backCarpet.matrix
				});
				listTransform.push({
					name :        'MOQUETTE',
					nodeLocalId : idMapping.backCarpet,
					transform :   backCarpet.textureTransform
				});
			}
			await app.viewer.batch([
				[
					'setProductNodesInstancesMatrices',
					nodesMtx
				], [
					'transformMeshInstancesTextures',
					listTransform
				]
			]);
		}
	};

	async remove() {
		if (!this.viewerNode) {
			return;
		}
		await this.viewerNode.delete();
		this.viewerNode = null;
		this.currentLayoutId = null;
	};

	deduceAdequateCarpet() {
		const product = app.currentProduct;
		if (!product) {
			this.component_throwUserError('No current product available in storage!');
		}
		const layoutPart = product.getPart([ 'layout' ]);
		if (!layoutPart) {
			return null;
		}
		const layoutCurrentOption = layoutPart.currentOption;
		if (!layoutCurrentOption) {
			return null;
		}
		const layoutId = layoutCurrentOption.id;
		if (product.id === 'siae') {
			return {
				SKU : 'carpetImprint-siae'
			};
		} else {
			if (layoutId === 'shape-no-wall') {
				return {
					SKU :   'carpetImprint-' + product.id + '-fourSide',
					sides : [ 'front', 'left', 'right', 'back' ]
				};
			} else if (layoutId === 'shape-back') {
				return {
					SKU :   'carpetImprint-' + product.id + '-threeSide',
					sides : [ 'front', 'left', 'right' ]
				};
			} else if (layoutId === 'shape-back-left') {
				return {
					SKU :   'carpetImprint-' + product.id + '-twoSideRight',
					sides : [ 'front', 'right' ]
				};
			} else if (layoutId === 'shape-back-right') {
				return {
					SKU :   'carpetImprint-' + product.id + '-twoSide',
					sides : [ 'front', 'left' ]
				};
			} else if (layoutId === 'shape-left-back-right') {
				return {
					SKU :   'carpetImprint-' + product.id + '-oneSide',
					sides : [ 'front' ]
				};
			} else {
				return null;
			}
		}
	};

	override async component_initialize() {
		await super.component_initialize();
	};

	override async component_start(startEvent : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(startEvent);
		if (!app.viewer.planner) {
			this.component_throwUserError('');
		}
		const carpetImprintComponentBusiness = app.component_configuration.productsComponents.find(x => x.type ===
			'carpetImprint' &&
			x.products.includes('business'));
		const carpetImprintComponentPrestige = app.component_configuration.productsComponents.find(x => x.type ===
			'carpetImprint' &&
			x.products.includes('prestige'));
		const carpetImprintComponentSIAE = app.component_configuration.productsComponents.find(x => x.type ===
			'carpetImprint' &&
			x.products.includes('siae'));
		const carpetImprintComponentConfort = app.component_configuration.productsComponents.find(x => x.type ===
			'carpetImprint' &&
			x.products.includes('confort'));
		const productsSchema : ViewerComponent.Product.IDescriptor[] = [];
		if (app.component_configuration.products.find(x => x.SKU === 'siae')) {
			if (!carpetImprintComponentSIAE) {
				throw STD.errors.user('Missing Carpet Imprint Component');
			}
			productsSchema.push({
				SKU :   'carpetImprint-siae',
				nodes : [
					app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
					{
						SKU :                         <string> carpetImprintComponentSIAE.viewerComponentSKU,
						projectCode :                 <string> carpetImprintComponentSIAE.viewerProjectCode,
						localId :                     'frontCarpet',
						parentLocalId :               'global',
						snappable :                   false,
						fixedPositionSetIds :         null,
						draggable :                   false,
						doNotListAsProductComponent : true,
						matrix :                      app.viewer.mtx(
							[ 0, 0, 0 ],
							[ 0, 0, 0 ],
							0
						)
					}
				]
			});
		}
		if (app.component_configuration.products.find(x => x.SKU === 'confort')) {
			if (!carpetImprintComponentConfort) {
				throw STD.errors.user('Missing Carpet Imprint Component');
			}
			productsSchema.push(
				{
					SKU :   'carpetImprint-confort-fourSide',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentConfort.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentConfort.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentConfort.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentConfort.viewerProjectCode,
							localId :                     'leftCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentConfort.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentConfort.viewerProjectCode,
							localId :                     'rightCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentConfort.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentConfort.viewerProjectCode,
							localId :                     'backCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				},
				{
					SKU :   'carpetImprint-confort-threeSide',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentConfort.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentConfort.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentConfort.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentConfort.viewerProjectCode,
							localId :                     'leftCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentConfort.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentConfort.viewerProjectCode,
							localId :                     'rightCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				},
				{
					SKU :   'carpetImprint-confort-twoSide',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentConfort.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentConfort.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentConfort.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentConfort.viewerProjectCode,
							localId :                     'leftCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				},
				{
					SKU :   'carpetImprint-confort-twoSideRight',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentConfort.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentConfort.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentConfort.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentConfort.viewerProjectCode,
							localId :                     'rightCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				},
				{
					SKU :   'carpetImprint-confort-oneSide',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentConfort.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentConfort.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				}
			);
		}
		if (app.component_configuration.products.find(x => x.SKU === 'prestige')) {
			if (!carpetImprintComponentPrestige) {
				throw STD.errors.user('Missing Carpet Imprint Component');
			}
			productsSchema.push(
				{
					SKU :   'carpetImprint-prestige-fourSide',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentPrestige.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentPrestige.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentPrestige.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentPrestige.viewerProjectCode,
							localId :                     'leftCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentPrestige.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentPrestige.viewerProjectCode,
							localId :                     'rightCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentPrestige.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentPrestige.viewerProjectCode,
							localId :                     'backCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				},
				{
					SKU :   'carpetImprint-prestige-threeSide',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentPrestige.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentPrestige.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentPrestige.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentPrestige.viewerProjectCode,
							localId :                     'leftCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentPrestige.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentPrestige.viewerProjectCode,
							localId :                     'rightCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				},
				{
					SKU :   'carpetImprint-prestige-twoSide',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentPrestige.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentPrestige.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentPrestige.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentPrestige.viewerProjectCode,
							localId :                     'leftCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				},
				{
					SKU :   'carpetImprint-prestige-twoSideRight',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentPrestige.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentPrestige.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentPrestige.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentPrestige.viewerProjectCode,
							localId :                     'rightCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				},
				{
					SKU :   'carpetImprint-prestige-oneSide',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentPrestige.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentPrestige.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				}
			);
		}
		if (app.component_configuration.products.find(x => x.SKU === 'business')) {
			if (!carpetImprintComponentBusiness) {
				throw STD.errors.user('Missing Carpet Imprint Component');
			}
			productsSchema.push(
				{
					SKU :   'carpetImprint-business-fourSide',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentBusiness.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentBusiness.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentBusiness.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentBusiness.viewerProjectCode,
							localId :                     'leftCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentBusiness.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentBusiness.viewerProjectCode,
							localId :                     'rightCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentBusiness.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentBusiness.viewerProjectCode,
							localId :                     'backCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				},
				{
					SKU :   'carpetImprint-business-threeSide',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentBusiness.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentBusiness.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentBusiness.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentBusiness.viewerProjectCode,
							localId :                     'leftCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentBusiness.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentBusiness.viewerProjectCode,
							localId :                     'rightCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				},
				{
					SKU :   'carpetImprint-business-twoSide',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentBusiness.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentBusiness.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentBusiness.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentBusiness.viewerProjectCode,
							localId :                     'leftCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				},
				{
					SKU :   'carpetImprint-business-twoSideRight',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentBusiness.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentBusiness.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						},
						{
							SKU :                         <string> carpetImprintComponentBusiness.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentBusiness.viewerProjectCode,
							localId :                     'rightCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				},
				{
					SKU :   'carpetImprint-business-oneSide',
					nodes : [
						app.viewer.createEmptyNodeDescriptor('global', 'root', 1),
						{
							SKU :                         <string> carpetImprintComponentBusiness.viewerComponentSKU,
							projectCode :                 <string> carpetImprintComponentBusiness.viewerProjectCode,
							localId :                     'frontCarpet',
							parentLocalId :               'global',
							snappable :                   false,
							fixedPositionSetIds :         null,
							draggable :                   false,
							doNotListAsProductComponent : true,
							matrix :                      app.viewer.mtx(
								[ 0, 0, 0 ],
								[ 0, 0, 0 ],
								0
							)
						}
					]
				}
			);
		}
		(<any> this).plannerCategory = app.viewer.createCategory({
			name :        'carpet-imprint',
			menuActions : {
				edit :      false,
				delete :    false,
				rotate :    false,
				duplicate : false
			},
			products :    productsSchema
		});
	}

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingPlinthComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = StandingPlinthComponent;
	export type Component = StandingPlinthComponent;
	export type Configuration = IStandingPlinthComponentConfiguration;
}
CM.declare({
	id :   'standing-carpetImprint',
	type : StandingPlinthComponent
});
